@if (resource) {
<div
    class="toggle"
    [class.toggle--loading]="loading"
    [ngClass]="'toggle--' + resource.getState()"
>
    @if (!loading) {
    <i class="fas fa-check"></i>
    } @if (loading) {
    <i class="fas fa-spinner-third fa-spin"></i>
    }
</div>
}
